
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/my-account/calendars",
      function () {
        return require("private-next-pages/settings/my-account/calendars.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/my-account/calendars"])
      });
    }
  